import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';
import IconAlert from '@/components/common/IconAlert';
import NewPlannerForm from './NewPlannerForm';

const KEYWORD_PLANNER_NO_DATA_HELP_URL =
  'https://help.mizfa.tools/reason-for-not-displaying-keyword-search-volume/';

type NoKeywordPlannerDataProps = {
  variant?: 'welcome' | 'emptyResults';
};

const NoKeywordPlannerResultsAlert = () => (
  <IconAlert variant="warning">
    برای این درخواست کیورد پلنر هیچ کلمه کلیدی پیشنهادی یافت نشد. ممکن است
    کلمه پایه، زبان یا موقعیت جغرافیایی انتخاب‌شده با داده‌های گوگل ادز
    هم‌خوانی نداشته باشد؛ همچنین گوگل ادز برای برخی دسته‌بندی‌ها از جمله
    کلمات پزشکی محدودیت دارد. پیشنهاد می‌کنیم با تغییر کلمه پایه، گسترش
    ایده‌ها یا ثبت درخواست جدید دوباره تلاش کنید.{' '}
    <a
      target="_blank"
      rel="noreferrer noopener"
      href={KEYWORD_PLANNER_NO_DATA_HELP_URL}
    >
      (اطلاعات بیشتر)
    </a>
  </IconAlert>
);

const NoKeywordPlannerData = ({
  variant = 'welcome'
}: NoKeywordPlannerDataProps) => {
  if (variant === 'emptyResults') {
    return <NoKeywordPlannerResultsAlert />;
  }

  return (
    <div className="justify-content-center align-items-center">
      <NewPlannerForm />
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center">
        برای شروع پلنر، کلمه رو وارد کن و دکمه جستجو رو بزن.
      </div>
    </div>
  );
};

export default NoKeywordPlannerData;
